import React from "react";
import ufo from "../Pictures/ufo.png";

function Workbench() {
  return (
    <div className="workbench">
      <h2 className="workbench-title">Workbench</h2>
      <div className="workbench-items">
        <div className="workbench-item-description">
          <img src={ufo} className="workbench-item-picture" />
          <div className="workbench-item-description-text">
            Increase your $ALN production by buying a new UFO
          </div>
        </div>
        <button
          className="shop-button"
          onClick={() => (window.location.href = "/shop")}
        >
          Go to shop
        </button>
      </div>
    </div>
  );
}

export default Workbench;
